import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-filter-catering',
    templateUrl: './filter-catering.component.html',
    styleUrls: ['./filter-catering.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FilterCateringComponent implements OnInit {

	@Input() lists: any;
	@Input() filterArguments: any;
	@Input() currentProject?: any;
	@Input() loading: boolean = true;
	@Output() closeView = new EventEmitter<string>();
	@Output() notify = new EventEmitter<string>();

	arguments: any = [];
	dropdownLists: any;

	submitForm() {
		this.notify.emit(this.arguments);
	}
	close() {
		this.closeView.emit();
	}

	constructor() { }

	ngOnInit() {
	}
	
	ngOnChanges(changes: SimpleChanges) {
		if(changes.lists){
			this.arguments = Object.assign({}, this.filterArguments);
			this.dropdownLists = JSON.parse(JSON.stringify(this.lists));
		}
	}

}
